/**
 * Created by User on 16/12/2016.
 */
import AdConsts from '../AdConsts';

export default LiveAdPlugin;

function LiveAdPlugin(root) {
  var adlist;
	
  LiveAdPlugin.startTimestamp = void 0;
  LiveAdPlugin.isLiveAd = false;
  LiveAdPlugin.getCurrentTimestamp = function() {
    return LiveAdPlugin.startTimestamp + root.player.get('position');
  };
  LiveAdPlugin.resetStartTimestamp = function () {
    root.player.on('player:hls:chunkLoaded', onChunkLoaded);
  };
	
  //get timestamp at start
  LiveAdPlugin.resetStartTimestamp();
	
	
  root.player.on('property:' + AdConsts.MNS_ADLIST, onMnsAdlist);
	 
  function onChunkLoaded(event) {
    root.player.off('player:hls:chunkLoaded', onChunkLoaded);
		
    var name = event.data.frag.url;
    var index = name.lastIndexOf('?');
    var currentTimestamp = Math.round(new Date().getTime() / 1000);
    if (index != -1) {
      name = name.substring(0, index);
    }
    index = name.lastIndexOf('/');
    if (index != -1) {
      name = name.slice(index + 1);
    }
    if (name) {
      var matches = name.match(/_\d+/);
      if (matches && matches.length > 0) {
        var timestampFromName = matches[0];
        timestampFromName = timestampFromName.substr(1);
        try {
          timestampFromName = parseInt(timestampFromName);
        } catch (error) {
          timestampFromName = currentTimestamp;
        }
				
        if (root.player && root.player.config && root.player.config.debug) {
          console.log('TIMESTAMP FROM NAME', new Date(timestampFromName * 1000));
        }
				
        LiveAdPlugin.startTimestamp = timestampFromName;
      }
    }
    if (!timestampFromName) {
      LiveAdPlugin.startTimestamp = currentTimestamp;
    }
		
    if (adlist) {
      root.setAdlist({ Adlist: processAdlist(adlist) });
      adlist = null;
    }
  }
	
  function onMnsAdlist(event) {
    LiveAdPlugin.isLiveAd = true;
    adlist = event.data;
		
    if (LiveAdPlugin.startTimestamp !== undefined) {
      root.setAdlist({ Adlist: processAdlist(adlist) });
      adlist = null;
    }
  }
	
  function processAdlist(adlist) {
    var currentTimestamp = LiveAdPlugin.startTimestamp;
    var newAdlist = [];
    var dT;
    for (var i = 0, l = adlist.length; i < l; ++i) {
      if (adlist[i].time_end > 1000000) {
        if (root.player && root.player.config && root.player.config.debug) {
          console.log('%c' + new Date(adlist[i].time_start * 1000) + ' | ' + new Date(adlist[i].time_end * 1000)
            ,'background: black; color: white');
        }
        dT = adlist[i].time_end - currentTimestamp;
        if (dT <= 0) {
          continue;
        }
      }
      newAdlist.push(adlist[i]);
    }
    return newAdlist;
  }
	
}